{
  "$id": "wealthlane://forms/release/rules",
  "validations": [
    {
      "id": "release-name-required",
      "fields": [
        "name"
      ],
      "when": {
        "meta": "mode",
        "in": [
          "create",
          "edit"
        ]
      },
      "rules": [
        {
          "type": "required",
          "message": "Name is required."
        }
      ]
    },
    {
      "id": "release-expected-date-required",
      "fields": [
        "expectedReleaseDate"
      ],
      "when": {
        "meta": "mode",
        "in": [
          "create",
          "edit"
        ]
      },
      "rules": [
        {
          "type": "required",
          "message": "Expected Release Date is required."
        },
        {
          "type": "custom",
          "message": "Expected Release Date is invalid.",
          "expression": "value !== 'Invalid date'"
        }
      ]
    }
  ],
  "effects": [
    {
      "id": "sync-session-checkboxes",
      "when": {
        "field": "#/properties/ignoreBrokerage"
      },
      "actions": [
        {
          "type": "emit",
          "event": "release.session.sync",
          "payload": {
            "ignoreBrokerage": "{field:ignoreBrokerage}",
            "soldShareOnlyToBroker": "{field:soldShareOnlyToBroker}"
          }
        }
      ]
    },
    {
      "id": "mark-submitted-on-create-save",
      "when": {
        "meta": "mode",
        "equals": "create"
      },
      "on": "submitSuccess",
      "actions": [
        {
          "type": "set",
          "field": "submitted",
          "value": true
        }
      ]
    }
  ],
  "observers": [
    {
      "id": "fetch-edit-hydrate",
      "dependsOn": [],
      "actionId": "GET_RELEASE_FOR_EDIT",
      "when": {
        "meta": "mode",
        "equals": "edit"
      },
      "onSuccess": [
        {
          "type": "set",
          "field": "submitted",
          "value": true
        }
      ]
    }
  ]
}
